import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { PortType, RootState } from 'types';
import { MapControlsInterface } from 'types/functions';
import { ActionsType } from 'types/system';
import { getMode } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface EraseAllModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;
    id?: string;
    mapControls: MapControlsInterface;
    //unused props
    data: any;
    mode: string;
    actions: ActionsType | undefined;

    //unused props
    port: PortType;
}

interface EraseAllModelState {
    //unused state
    errors: object;

    //unused state
    data: any | null;

    loading: boolean;
}

class EraseAllModel extends Component<EraseAllModelProps, EraseAllModelState> {
    constructor(props: EraseAllModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        const count = this.props.mapControls[getMode(this.props.mode)]?.getDrawingCount();
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Erase all drawing objects')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="flex items-center gap-1 text-md text-gray-800">
                        {translate('Are you sure you want to erase all drawing objects?', { count: count })}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-delete rounded-md text-white"
                            >
                                {translate('Erase')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const eraseAllModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const eraseAllModelDispatchToProps = () => ({});

export default connect(eraseAllModelStateToProps, eraseAllModelDispatchToProps)(EraseAllModel);
